
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './gossip.json';

const Gossip = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Social communication, rumors, and workplace dynamics vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Gossip"
            image="/Images/gossip.webp"
            seoTitle="Free English Lesson Plans: Gossip"
            seoDescription="Social communication, rumors, and workplace dynamics vocabulary. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Gossip;


